import { ShopService } from "./../shop.service";
import { SubscriptionService } from "@app/app/subscription/subscription.service";
import { filter, map } from "rxjs/operators";
import { ScrollToLastPosition } from "@app/helper/scroll-to-last-position";
import { DeviceService, CacheObjectService } from "@app/core";
import { IndicatorService } from "@app/shared";
import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { Router, ActivatedRoute, NavigationStart } from "@angular/router";

@Component({
  selector: "navaar-list-item-shop",
  templateUrl: "./list-item-shop.component.html",
  styleUrls: ["./list-item-shop.component.scss"],
})
export class ListItemShopComponent extends ScrollToLastPosition
  implements OnInit {
  public title: string;
  public identifier: number;
  public items: Array<any> = [];
  public isLoading: boolean = false;
  public isEnd: boolean = false;
  public keyUrl: string;
  public currentPage: number = 0;
  public skip: number = 0;
  public readonly PAGE_SIZE = 20;
  public pages: number = 0;
  public total: number = 0;
  public get pageNo(): number {
    return this.cache.pageNumer;
  }
  public set pageNo(v: number) {
    this.cache.pageNumer = v;
  }

  constructor(
    private readonly indicator: IndicatorService,
    private readonly chkd: ChangeDetectorRef,
    public readonly device: DeviceService,
    private readonly shopService: ShopService,
    private readonly cache: CacheObjectService<any>,
    private readonly subscriptionService: SubscriptionService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {
    super(router);
    this.device.hide();
    this.subscriptionService.isEndedSubscription$.subscribe((c) => {
      if (c) this.subscriptionService.setStatusEndedRemainigSubscription(true);
    });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (event.restoredState) this.shopService.isBackFromItem = true;
      });
  }
  public ngOnInit() {
    this.title = this.route.snapshot.queryParamMap.get("title");
    this.keyUrl = this.route.snapshot.queryParamMap.get("keyUrl");
    this.identifier = +this.route.snapshot.paramMap.get("id");
    this.items = [];
    this.loadBookAllList();
  }

  public goToPage(page: number) {
    this.paginate(page);
  }
  paginate(page) {
    this.pageNo = page;
    this.skip = this.pageNo * this.PAGE_SIZE;
    this.shopService.isBackFromItem = false;
    this.loadBookAllList();
  }

  public async loadBookAllList() {
    this.isLoading = true;
    let Url = `${this.keyUrl}?$inlinecount=allpages`;
    if (this.skip != undefined) {
      Url += `&$skip=${this.skip}`;
    }
    if (this.PAGE_SIZE != undefined) {
      Url += `&$top=${this.PAGE_SIZE}`;
    }
    await this.cache
      .getObjectCacheOfList(
        Url,
        `${this.keyUrl}/${this.identifier}`,
        this.pageNo
      )
      .pipe(
        map((res) => {
          this.isLoading = false;
          this.isEnd = res.items.length === res.total;
          this.items = res.items;
          this.total = res.total;
          this.pages = Math.ceil(this.total / this.PAGE_SIZE);
          this.indicator.hide();
          this.indicator.hideHude();
          this.chkd.detectChanges();
          return res;
        })
      )
      .toPromise();
    if (this.shopService.isBackFromItem) super.scrollToPosition();
  }
}
